import React, { Component, Fragment, Suspense } from "react";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";
import moment from "moment";

import { previewDocument, Signature, selectProps, dateFormat, imagePath } from "utils";
import { DOCUMENT_TYPE_SIGNATURE } from "constants/dbValues";
import * as GridGallery from "react-grid-gallery";

import { Icon, Select, Divider } from "antd";
import { Card } from "components";

import { documentService, selectService } from "services";

// Composant qui gère la gestion des documents contextuellement dans
// le bas d'une page de détails (ex.: Documents liés à une tailgate X)
// Comme on veut que les documents soit associés correctement,
// on buffer toutes les actions à porter, et une fois le traitement fait
// sur la page détails, on éxécute les actions dans le buffer.

var lastid = 0;
const generateId = () => `tmp-${lastid++}`;

class DocumentsList extends Component {
  constructor(props) {
    super(props);
    this._isMounted = true;
    this.state = {
      creation: false,
      types: [],

      actions: [],
    };

    this.addAction = this.addAction.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);

    this.deleteDocument = this.deleteDocument.bind(this);
    this.createDocument = this.createDocument.bind(this);

    this.startDocumentCreation = this.startDocumentCreation.bind(this);
    this.cancelDocumentCreation = this.cancelDocumentCreation.bind(this);

    this.executeActions = this.executeActions.bind(this);
  }

  async componentDidMount() {
    if (!this.props.editable) return;
    const selects = await selectService.listForPage("document");

    var types = [...selects.DocumentType];
    if (this.props.displaySignatures) types = types.filter((t) => t.id === DOCUMENT_TYPE_SIGNATURE);

    this.setState({ types: types });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  addAction(action) {
    const actions = this.state.actions.filter((a) => a.doc.id !== action.doc.id);

    // Si on delete un document tmp, on veut pas d'action de delete, on veut seulement retirer celle de création
    if (action.type === "delete" && String(action.doc.id).indexOf("tmp-") !== -1)
      this.setState({ actions: [...actions] });
    else this.setState({ actions: [...actions, action] });
  }

  downloadDocument(doc) {
    documentService.get(doc.id).then((blob) => saveAs(blob, doc.filename));
  }

  createDocument(doc) {
    if (!doc.type_id || !doc.url) return;

    var formattedDoc = {
      id: generateId(),
      tmp: true,

      url: doc.url,
      type_id: doc.type_id,
      extension: doc.url.type,
      filename: doc.url.name,
    };

    var documents = [...this.props.documents, formattedDoc];
    this.props.handleChange(documents, "documents");

    this.setState({ creation: false });
    this.addAction({ type: "create", doc: formattedDoc });
  }

  deleteDocument(doc) {
    var { documents } = this.props;
    documents = documents.filter((d) => d.id !== doc.id);
    this.props.handleChange(documents, "documents");

    this.addAction({ type: "delete", doc: doc });
  }

  startDocumentCreation() {
    var base = this.props.displaySignatures
      ? {
          type_id: DOCUMENT_TYPE_SIGNATURE,
          document_type: this.state.types.find((t) => t.id === DOCUMENT_TYPE_SIGNATURE),
        }
      : {};
    this.setState({ creation: base });
  }

  cancelDocumentCreation() {
    this.setState({ creation: false });
  }

  handleCreationChange(value, key) {
    if (this.state.creation === false) return;
    if (key === "type_id") {
      this.setState({
        creation: {
          ...this.state.creation,
          [key]: value,
          document_type: this.state.types.find((t) => t.id === value),
        },
      });
    } else if (key === "url") {
      const creation = { ...this.state.creation, [key]: value };
      this.setState({ creation });
      this.createDocument(creation);
    } else {
      this.setState({ creation: { ...this.state.creation, [key]: value } });
    }
  }

  async executeActions(target_id, model) {
    var promises = this.state.actions.map((a) => {
      if (a.type === "create")
        return documentService.create({
          ...a.doc,
          target_id,
          model,
          label: `(${moment().format(dateFormat)})`,
        });
      else if (a.type === "delete") return documentService.remove(a.doc);
    });

    await Promise.all(promises);
  }

  render() {
    const { editable, displaySignatures, galleryLink } = this.props;
    const { creation } = this.state;

    var { documents } = this.props;
    var signatures = [];

    if (displaySignatures && !editable) {
      signatures = documents.filter((d) => d.type_id === DOCUMENT_TYPE_SIGNATURE);
      documents = documents.filter((d) => d.type_id !== DOCUMENT_TYPE_SIGNATURE);
    }

    const icon = (doc) => {
      if (doc.tmp) return "clock-circle";
      if (doc.type_id === DOCUMENT_TYPE_SIGNATURE) return "highlight";
      if (doc.extension.indexOf("image") !== -1) return "file-image";
      return "file-text";
    };

    const showSignatures = displaySignatures && signatures.length > 0;

    return (
      <div className="documents-list">
        {(editable ||
          (documents && documents.length > 0) ||
          (signatures && signatures.length > 0)) && <Divider />}

        {showSignatures && (
          <div className="signatures-list">
            <p className="title">Signatures :</p>
            {signatures.map((s, i) => (
              <Signature key={i} doc={s} />
            ))}
          </div>
        )}

        {showSignatures && documents && documents.length > 0 && (
          <p className="title">Autres documents :</p>
        )}
        <ul>
          {(documents || []).map((d, i) => (
            <li key={i}>
              <span className="actions-list">
                <Icon
                  type="cloud-download"
                  disabled={d.tmp}
                  onClick={() => !d.tmp && this.downloadDocument(d)}
                />
                {editable && <Icon type="delete" onClick={() => this.deleteDocument(d)} />}
              </span>

              <a className="file-name" onClick={() => previewDocument(d)} disabled={d.tmp}>
                <Icon type={icon(d)} />
                {d.filename}
              </a>
            </li>
          ))}

          {creation !== false && (
            <li className="new-document">
              <span className="actions-list">
                {/* <Icon type="plus" onClick={ () => this.createDocument(creation) } disabled={ (!creation.type_id || !creation.url) } /> */}
                <Icon type="close" onClick={() => this.cancelDocumentCreation()} />
              </span>

              <span className="file">
                <Select
                  size="small"
                  {...selectProps()}
                  onChange={(value) => this.handleCreationChange(value, "type_id")}
                  value={creation.type_id}
                >
                  {this.state.types.map((item) => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.label}
                    </Select.Option>
                  ))}
                </Select>

                <input
                  type="file"
                  accept={(creation.document_type || {}).accept || "*"}
                  onChange={(e) => this.handleCreationChange(e.target.files[0], "url")}
                  disabled={!creation.type_id}
                />
              </span>
            </li>
          )}
        </ul>

        {editable && creation === false && (
          <a className="new-document-btn" onClick={this.startDocumentCreation}>
            {displaySignatures ? "+ Nouvelle signature" : "+ Nouveau document"}
          </a>
        )}
      </div>
    );
  }
}

DocumentsList.Preview = (props) => {
  const { documents = [] } = props;
  if (documents.length === 0) return <></>;

  return (
    <ul className="documents-list-preview">
      {documents.map((d, i) => (
        <li onClick={() => previewDocument(d)} key={i}>
          <img src={imagePath(d.url, true)} />
        </li>
      ))}
    </ul>
  );
};

export default DocumentsList;
